export const ROUTE_PATH = '/clean/cleaner/check-items' as const
